import queryString from "query-string";

export const encodeCurrentPath = (): string => {
	if (!window.location) return "";
	return encodeURI(window.location.pathname) + encodeURIComponent(window.location.search);
};

export function withQueryParams(url: string, query: { [key: string]: string }) {
	return queryString.stringifyUrl({ url, query });
}

/**
 * Checks if a string is a valid URL by calling the URL constructor on it.
 * @param url potential url
 */
export const isValidUrl = (url: string) => {
	try {
		const urlObj = new URL(url);
		return urlObj.protocol === "http:" || urlObj.protocol === "https:";
	} catch (error) {
		return false;
	}
};

/**
 * It is necessary to define two instances of essentially the same link-detecting regex
 * as the one used for inputRules must finish with '$', but this will not work in feedback
 * since it is not prose (no inputRules) and should instead expect whitespace, new line, or end of line
 */
const linkRegexInner = /(https?:\/{2}[\w.-]+(?::\d{2,5})?(?:[/?#]\S*)?)/;
export const linkRegexNewline = new RegExp(linkRegexInner.source + /\s$/.source, "gm");
export const linkRegexInline = new RegExp(linkRegexInner.source + /(\s|\r|$|\b)/.source, "g");

/**
 * Takes a potential URL and if it can't be parsed by the URL constructor ads https to the start, if that helps
 * @param url potential url
 */
export const addHttpsToNonUrls = (url: string) => {
	if (!isValidUrl(url)) {
		const newUrl = `https://${url}`;
		if (isValidUrl(newUrl)) {
			return newUrl;
		}
	}

	return url;
};
